import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-aktion-entfernen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAktionEntfernenEffects {

    VeranstaltungAktionEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_AKTION_ENTFERNEN),
        mergeMap((x: ac.PostVeranstaltungAktionEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungAktionEntfernen(x.aktionRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungAktionEntfernenErfolgreichAction(result, x.aktionRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungAktionEntfernenFehlerAction(error, x.aktionRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
